import { BaseShapeDataModel } from './base-shape-data-model';
import type { IEventManager } from '../manager/event-manager';
import type { PageContext } from '../context/page-context';
import type { IGraphicFrameBaseData } from '../data/shape-data';
import type { GroupShapeDataModel } from './group-shape-data-model';

export abstract class GraphicFrameBaseDataModel<
    IGraphicFrameData extends IGraphicFrameBaseData,
> extends BaseShapeDataModel<IGraphicFrameData> {
    public constructor(
        data: IGraphicFrameData,
        events: IEventManager,
        context: PageContext,
        public parent: GroupShapeDataModel,
    ) {
        super(events, context);
    }
}
